"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantType = void 0;
/**
 * Authentication grant types.
 * These are used when populating the 'grant_type' parameter.
 */
var GrantType;
(function (GrantType) {
    /**
     * Used when either requesting a client grant or an
     * anonymous customer access token:
     * https://docs.commercetools.com/api/authorization#client-credentials-flow
     * https://docs.commercetools.com/api/authorization#tokens-for-anonymous-sessions
     */
    GrantType["CLIENT_CREDENTIALS"] = "client_credentials";
    /**
     * Used when refreshing any existing access token (whether client or customer):
     * https://docs.commercetools.com/api/authorization#refresh-token-flow
     */
    GrantType["REFRESH_TOKEN"] = "refresh_token";
    /**
     * Used when attempting to login a customer:
     * https://docs.commercetools.com/api/authorization#password-flow
     */
    GrantType["PASSWORD"] = "password";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
//# sourceMappingURL=types.js.map